export default __webpack_public_path__ + "static/media/visa.8b153f4f.svg";